import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from './shared.module';
import { PublicModule } from './public.module';

import { AuthenticationGuard } from '@app/guards/authentication.guard';
import { PermissionGuard } from '@app/guards/permission.guard';
import { EditionsGuard } from '@app/guards/editions.guard';
import { Role } from '@app/models/user';
import { VariousGuard } from '@app/guards/various.guard';
import { TotpGuard } from '@app/guards/totp.guard';
import { WaitingRoomGuard } from '@app/guards/waiting-room.guard';

import { UserEditComponent } from '@app/components/_public/user-edit/user-edit.component';
import { ChildEditComponent } from '@app/components/_user/children/edit/child-edit.component';
import { PreinscriptionEditComponent } from '@app/components/_user/preinscription/edit/preinscription-edit.component';
import { UserReservationEditComponent } from '@app/components/_user/reservation/edit/edit.component';
import { PlanningSelectDialogComponent } from '@app/components/_user/reservation/planning/select-dialog/select-dialog.component';
import { AccountComponent } from '@app/components/_user/account/account.component';
import { UserInfoComponent } from '@app/components/_user/user-info/user-info.component';
import { AssmatInfoComponent } from '@app/components/_user/assmat-info/assmat-info.component';
import { PreinscriptionListComponent } from '@app/components/_user/preinscription/list/preinscription-list.component';
import { ChildrenListComponent } from '@app/components/_user/children/list/children-list.component';
import { FactureComponent } from '@app/components/_user/facture/facture.component';
import { ReservationsComponent } from '@app/components/_user/reservation/reservations.component';
import { PaiementComponent } from '@app/components/_user/facture/paiement/paiement.component';
import { FoyerComponent } from '@app/components/_user/foyer/foyer.component';
import { FoyerEditComponent } from '@app/components/_user/foyer/foyer-edit/foyer-edit.component';
import { ConjointEditComponent } from '@app/components/_user/conjoint-edit/conjoint-edit.component';
import { PlanningDetailsDialogComponent } from '@app/components/_user/reservation/planning/details-dialog/details-dialog.component';
import { GedComponent } from '@app/components/_user/ged/ged.component';
import { PresenceRepeatComponent } from '@app/components/_user/reservation/planning/presence-repeat/presence-repeat.component';
import { ReservationPanierComponent } from '@app/components/_user/reservation/panier/panier.component';
import { MikadoNewPresenceComponent } from '@app/components/_user/reservation/planning/mikado-new-presence/mikado-new-presence.component';
import { AssmatPointageComponent } from '@app/components/_user/assmat-pointage/assmat-pointage.component';
import { TicketDematComponent } from '@app/components/_user/ticket-demat/ticket-demat.component';
import { AchatTicketComponent } from '@app/components/_user/ticket-demat/achat-ticket/achat-ticket.component';
import { EditionListComponent } from '@app/components/_user/edition/edition-list.component';
import { LasidoPreinscriptionComponent } from '@app/components/_user/lasido-preinscription/lasido-preinscription.component';
import { LasidoPreinscriptionEditComponent } from '@app/components/_user/lasido-preinscription/edit/edit.component';
import { AssmatInfoEditComponent } from '@app/components/_user/assmat-info/assmat-info-edit/assmat-info-edit.component';
import { AssmatAvailabilityComponent } from '@app/components/_user/assmat-info/assmat-availability/assmat-availability.component';
import { ContratAccueilMentaloListComponent } from '@app/components/_user/contrats-accueil-mentalo/contrat-accueil-mentalo-list/contrat-accueil-mentalo-list.component';
import { ContratAccueilMentaloEditComponent } from '@app/components/_user/contrats-accueil-mentalo/contrat-accueil-mentalo-edit/contrat-accueil-mentalo-edit.component';
import { InscriptionAnimationsComponent } from '@app/components/_user/animations/inscription-animations/inscription-animations.component';
import { InscriptionReunionsComponent } from '@app/components/_user/reunions/inscription-reunions/inscription-reunions.component';
import { ListAnimationsComponent } from '@app/components/_user/animations/list-animations/list-animations.component';
import { ListReunionsComponent } from '@app/components/_user/reunions/list-reunions/list-reunions.component';
import { PresenceListComponent } from '@app/components/_user/reservation/planning/presence-list/presence-list.component';
import { LasidoInscriptionComponent } from '@app/components/_user/lasido-inscription/lasido-inscription.component';
import { RenouvellementInscriptionComponent } from '@app/components/_user/lasido-inscription/renouvellement-inscription/renouvellement-inscription.component';
import { CogitoPreinscriptionComponent } from '@app/components/_user/cogito-preinscription/cogito-preinscription.component';
import { EditCogitoPreinscriptionComponent } from '@app/components/_user/cogito-preinscription/edit-cogito-preinscription/edit-cogito-preinscription.component';
import { ListAnimationsReunionsComponent } from '@app/components/_user/list-animations-reunions/list-animations-reunions.component';
import { EditPhotoComponent } from '@app/components/_user/children/edit-photo/edit-photo.component';
import { CogitoInscriptionsComponent } from '@app/components/_user/cogito-inscriptions/cogito-inscriptions.component';
import { EditCogitoInscriptionComponent } from '@app/components/_user/cogito-inscriptions/edit-cogito-inscription/edit-cogito-inscription.component';
import { MandatsSepaComponent } from '@app/components/_user/mandats-sepa/mandats-sepa.component';
import { MandatSepaEditComponent } from '@app/components/_user/mandats-sepa/mandat-sepa-edit/mandat-sepa-edit.component';
import { MessagerieComponent } from '@app/components/_user/messagerie/messagerie.component';
import { FilePreviewComponent } from '@app/components/_user/ged/file-preview/file-preview.component';
import { FileUploadDialogComponent } from '@app/components/_user/ged/file-upload-dialog/file-upload-dialog.component';
import { DocDetailsComponent } from '@app/components/_user/ged/doc-details/doc-details.component';
import { MandatSepaPdfDialogComponent } from '@app/components/_user/mandats-sepa/mandat-sepa-pdf-dialog/mandat-sepa-pdf-dialog.component';
import { DiaboloInscriptionsComponent } from '@app/components/_user/diabolo-inscriptions/diabolo-inscriptions.component';
import { EditDiaboloInscriptionsComponent } from '@app/components/_user/diabolo-inscriptions/edit-diabolo-inscriptions/edit-diabolo-inscriptions.component';
import { UpdatePasswordComponent } from '@app/components/_user/update-password/update-password.component';
import { TotpManageComponent } from '@app/components/_user/totp-manage/totp-manage.component';
import { StudentsPointageComponent } from '@app/components/_user/enseignant-pointage/students-pointage/students-pointage.component';
import { EnseignantPointageComponent } from '@app/components/_user/enseignant-pointage/enseignant-pointage.component'
import { DemarchesListComponent } from '@app/components/_user/demarches/demarches-list.component';
import { DemarcheComponent } from '@app/components/_user/demarches/demarche/demarche.component';
import { DemarcheGedComponent } from '@app/components/_user/demarches/demarche-ged/demarche-ged.component';
import { DemarcheSelectStepComponent } from '@app/components/_user/demarches/demarche-select-step/demarche-select-step.component';
import { DemarcheQuestionStepComponent } from '@app/components/_user/demarches/demarche-question-step/demarche-question-step.component';
import { AssmatFormationComponent } from '@app/components/_user/assmat-info/assmat-formation/assmat-formation.component';
import { ListEvaluationComponent } from '@app/components/_user/enseignant-evaluation/list-evaluation/list-evaluation.component';
import { EditEvaluationComponent } from '@app/components/_user/enseignant-evaluation/edit-evaluation/edit-evaluation.component';
import { EvaluationCardViewComponent } from '@app/components/_user/enseignant-evaluation/list-evaluation/views/evaluation-card-view/evaluation-card-view.component';
import { EvaluationTableViewComponent } from '@app/components/_user/enseignant-evaluation/list-evaluation/views/evaluation-table-view/evaluation-table-view.component';
import { EnseignantElevesComponent } from '@app/components/_user/enseignant-eleves/enseignant-eleves.component';
import { DossierPedagogiqueDialogComponent } from '@app/components/_user/enseignant-eleves/dossier-pedagogique-dialog/dossier-pedagogique-dialog.component';
import { DemandeContratAccueilComponent } from '@app/components/_user/demande-contrat-accueil/demande-contrat-accueil.component';
import { DemandeContratAccueilEditComponent } from '@app/components/_user/demande-contrat-accueil/demande-contrat-accueil-edit/demande-contrat-accueil-edit.component';
import { CarnetLiaisonComponent } from '@app/components/_user/carnet-liaison/carnet-liaison.component';
import { CarnetHeureFormatPipe, CarnetDureeFormatPipe } from '@app/components/_user/carnet-liaison/carnet-liaison.pipe';
import { CarnetTransmissionParentComponent } from '@app/components/_user/carnet-liaison/sections/carnet-transmission-parent/carnet-transmission-parent.component';
import { CarnetRepasComponent } from '@app/components/_user/carnet-liaison/sections/carnet-repas/carnet-repas.component';
import { CarnetSommeilComponent } from '@app/components/_user/carnet-liaison/sections/carnet-sommeil/carnet-sommeil.component';
import { CarnetHygieneComponent } from '@app/components/_user/carnet-liaison/sections/carnet-hygiene/carnet-hygiene.component';
import { CarnetActiviteComponent } from '@app/components/_user/carnet-liaison/sections/carnet-activite/carnet-activite.component';
import { CarnetMomentDeVieComponent } from '@app/components/_user/carnet-liaison/sections/carnet-moment-de-vie/carnet-moment-de-vie.component';
import { CarnetTraitementComponent } from '@app/components/_user/carnet-liaison/sections/carnet-traitement/carnet-traitement.component';
import { CarnetTransmissionProComponent } from '@app/components/_user/carnet-liaison/sections/carnet-transmission-pro/carnet-transmission-pro.component';
import { CarnetDevPsychomoteurComponent } from '@app/components/_user/carnet-liaison/sections/carnet-dev-psychomoteur/carnet-dev-psychomoteur.component';
import { CarnetLangageComponent } from '@app/components/_user/carnet-liaison/sections/carnet-langage/carnet-langage.component';
import { CarnetDiversificationComponent } from '@app/components/_user/carnet-liaison/sections/carnet-diversification/carnet-diversification.component';
import { CarnetDevPhysiologiqueComponent } from '@app/components/_user/carnet-liaison/sections/carnet-dev-physiologique/carnet-dev-physiologique.component';
import { EnseignantInfoComponent } from '@app/components/_user/enseignant-info/enseignant-info.component';
import { AvailabilityComponent } from '@app/components/_user/enseignant-info/availability/availability.component';
import { DepartmentTreeComponent } from '@app/components/_user/enseignant-info/department-tree/department-tree.component';


const userRoutes: Routes = [
  {
    path: '',
    canActivateChild: [AuthenticationGuard, VariousGuard],
    data: { roles: [Role.User], notForManager: true, title: 'menu.account' },
    children: [
      // Account index
      {
        path: '', pathMatch: 'full', component: AccountComponent, data: { title: 'menu.account' }
      },

      //catégorie des boards
      { path: 'part/:idCategorie', component: AccountComponent, data: { title: 'part' } },

      // Personal informations
      { path: 'user', component: UserInfoComponent },
      {
        path: 'user', data: { title: 'Utilisateur', disableAccountSwitch: true },
        children: [
          { path: 'edit', component: UserEditComponent, canActivate: [PermissionGuard], data: { perm: 'account_edit' } },
          // Keep readonly access to part of account data (form disabled)
          { path: ':step', component: UserEditComponent },
        ]
      },
      // handle possible former similar URLs for same component
      { path: 'profile', redirectTo: 'user' },
      { path: 'personal', redirectTo: 'user' },

      // Données du compte Famille
      // Foyer
      { path: 'foyer', component: FoyerComponent, canActivate: [PermissionGuard], data: { perm: 'foyer_access' } },
      {
        path: 'foyer', data: { title: 'Foyer', disableAccountSwitch: true }, children: [
          { path: 'edit', component: FoyerEditComponent, canActivate: [PermissionGuard], data: { perm: 'foyer_edit' } },
          { path: ':step', component: FoyerEditComponent },
        ]
      },

      // Conjoint
      { path: 'conjoint', redirectTo: 'foyer', pathMatch: 'full' },
      {
        path: 'conjoint', data: { title: 'Conjoint', disableAccountSwitch: true }, children: [
          { path: 'add/:idDemarche', component: DemarcheComponent, canActivate: [PermissionGuard], data: { perm: 'foyer_edit' } },
          { path: 'edit', component: ConjointEditComponent, canActivate: [PermissionGuard], data: { perm: 'foyer_edit' } },
          { path: ':step', component: ConjointEditComponent },
        ]
      },
      // Children
      { path: 'children', component: ChildrenListComponent, canActivate: [PermissionGuard], data: { perm: 'child_access' } },
      {
        path: 'children', data: { title: 'Enfants', disableAccountSwitch: true }, children: [
          {
            path: 'add', component: ChildEditComponent, canActivate: [PermissionGuard],
            data: { title: 'Nouvel enfant', perm: 'child_create' },
          },
          {
            path: 'add/:idDemarche', component: DemarcheComponent, canActivate: [PermissionGuard],
            data: { perm: 'child_create' },
          },
          {
            path: 'edit/:id', component: ChildEditComponent, canActivate: [PermissionGuard],
            data: { perm: 'child_edit' },
          },
          // Keep readonly access to part child data (form disabled)
          { path: 'edit/:id/:step', component: ChildEditComponent }
        ]
      },

      // Facturation - Paiement
      { path: 'factures', component: FactureComponent, canActivate: [PermissionGuard, TotpGuard], data: { perm: 'factures_access', totpRestrict: 'restrictFactures' } },
      { path: 'paiement/:regie', component: PaiementComponent, canActivate: [TotpGuard], data: { disableAccountSwitch: true, totpRestrict: 'restrictFactures' } },

      // Tickets dématarialisé
      { path: 'tickets', component: TicketDematComponent, canActivate: [PermissionGuard], data: { disableAccountSwitch: true, perm: 'tickets_access' } },
      {
        path: 'tickets', data: { title: 'Mes tickets', disableAccountSwitch: true },
        children: [
          { path: 'achat', component: AchatTicketComponent, data: { title: 'Achat de tickets', disableAccountSwitch: true } },
        ]
      },

      //Mandats SEPA
      { path: 'mandats-sepa', component: MandatsSepaComponent, canActivate: [PermissionGuard, TotpGuard], data: { disableAccountSwitch: true, perm: 'mandat_sepa_access', totpRestrict: 'restrictSEPA', validFamilyAccount: true } },
      {
        path: 'mandats-sepa',
        canActivateChild: [TotpGuard],
        data: { title: "Mandats SEPA", totpRestrict: 'restrictSEPA', validFamilyAccount: true },
        children: [
          { path: 'new', component: MandatSepaEditComponent, canActivate: [PermissionGuard], data: { perm: 'mandat_sepa_create', title: "Nouveau mandat SEPA" } },
          { path: ':id', component: MandatSepaEditComponent, canActivate: [PermissionGuard], data: { perm: 'mandat_sepa_edit', title: "Modification d'un mandat SEPA" } },
        ]
      },
      { path: 'documents', component: GedComponent, canActivate: [PermissionGuard, TotpGuard], data: { perm: 'document_access', totpRestrict: 'restrictGED' } },
      { path: 'editions', component: EditionListComponent, canActivate: [EditionsGuard], data: { disableAccountSwitch: true } },
      { path: 'messagerie', component: MessagerieComponent, canActivate: [PermissionGuard], data: { title: 'Messagerie', perm: 'messagerie_access' } },

      { path: 'update-password', component: UpdatePasswordComponent, canActivate: [VariousGuard], data: { title: 'Modification du mot de passe', notFromOIDC: true, notForManager: true } },
      { path: 'totp-manage', component: TotpManageComponent, data: { title: 'totp.title' } },

      // Pour Diabolo OU Mikado
      { path: 'reservations', component: ReservationsComponent, canDeactivate: [WaitingRoomGuard], data: { validFamilyAccount: true } },

      // Diabolo : reservations
      {
        path: 'reservations', data: { title: 'Réservations', disableAccountSwitch: true, validFamilyAccount: true }, children: [
          { path: 'panier', component: ReservationPanierComponent, canDeactivate: [WaitingRoomGuard] },
          { path: 'new', component: UserReservationEditComponent, canActivate: [PermissionGuard], canDeactivate: [WaitingRoomGuard] },
          { path: ':id', component: UserReservationEditComponent, canDeactivate: [WaitingRoomGuard] }
        ]
      },

      // Diabolo - Inscriptions
      { path: 'diabolo-inscriptions', component: DiaboloInscriptionsComponent, canActivate: [PermissionGuard], data: { perm: 'diabolo_inscriptions_access' } },
      {
        path: 'diabolo-inscriptions', data: { title: "diabolo.title_fil_ariane" }, children: [
          { path: 'new', component: EditDiaboloInscriptionsComponent, canActivate: [PermissionGuard], data: { perm: 'diabolo_inscriptions_create', title: "diabolo.new_inscription" } },
          { path: 'new/:idDemarche', component: DemarcheComponent, canActivate: [PermissionGuard], data: { perm: 'diabolo_inscriptions_create' } },
          { path: ':id', component: EditDiaboloInscriptionsComponent, canActivate: [PermissionGuard], data: { perm: 'diabolo_inscriptions_edit', title: "diabolo.edit_inscription" } },
        ]
      },

      // Preinscriptions Mikado
      { path: 'preinscription', component: PreinscriptionListComponent, canActivate: [PermissionGuard], data: { perm: 'preinscription_access' } },
      {
        path: 'preinscription', data: { title: 'Pré-inscriptions', disableAccountSwitch: true },
        children: [
          {
            path: 'add', component: PreinscriptionEditComponent, canActivate: [PermissionGuard],
            data: { title: 'Nouvelle pré-inscription', perm: 'preinscription_create' }
          },
          {
            path: 'add/:idDemarche', component: DemarcheComponent, canActivate: [PermissionGuard],
            data: { perm: 'preinscription_create' }
          },
          {
            path: 'edit/:id', component: PreinscriptionEditComponent, canActivate: [PermissionGuard],
            data: { perm: 'preinscription_edit' },
          },
          { path: 'edit/:id/:step', component: PreinscriptionEditComponent }
        ]
      },

      //Demande de contrat d'accueil
      { path: 'demande-contrat-accueil', component: DemandeContratAccueilComponent, canActivate: [PermissionGuard], data: { perm: 'demande_contrat_accueil_access' } },
      {
        path: 'demande-contrat-accueil', data: { title: 'Demande de contrat d\'accueil', disableAccountSwitch: true }, children: [
          {
            path: 'add', component: DemandeContratAccueilEditComponent, canActivate: [PermissionGuard],
            data: { title: "Nouvelle demande de contrat d'accueil", perm: 'demande_contrat_accueil_create' }
          },
          {
            path: 'edit/:id', component: DemandeContratAccueilEditComponent, canActivate: [PermissionGuard],
            data: { title: "Modification d'une demande de contrat d'accueil", perm: 'demande_contrat_accueil_edit' }
          },
          {
            path: 'edit/:id/:step', component: DemandeContratAccueilEditComponent
          }
        ]
      },


      /****************************************************************
       * Lasido
       ****************************************************************/
      // Lasido - Preinscriptions
      { path: 'lasido-preinscriptions', component: LasidoPreinscriptionComponent, canActivate: [PermissionGuard], data: { perm: 'lasido_access' } },
      {
        path: 'lasido-preinscriptions', data: { title: 'Préinscriptions' }, children: [
          { path: 'new', component: LasidoPreinscriptionEditComponent, canActivate: [PermissionGuard], data: { title: 'Nouvelle préinscription', perm: 'lasido_create' } },
          { path: 'new/:idDemarche', component: DemarcheComponent, canActivate: [PermissionGuard], data: { perm: 'lasido_create' } },
          { path: ':id', component: LasidoPreinscriptionEditComponent, canActivate: [PermissionGuard], data: { title: "Modification d'un préinscription", perm: 'lasido_edit' } },
        ]
      },

      // Lasido - Inscriptions-renouvellement
      { path: 'lasido-inscriptions', component: LasidoInscriptionComponent, canActivate: [PermissionGuard], data: { perm: 'lasido_renewal_inscriptions_access' } },
      {
        path: 'lasido-inscriptions', data: { title: 'inscriptions' }, children: [
          { path: ':id', component: RenouvellementInscriptionComponent, data: { title: 'Renouvellement inscription' } },
        ]
      },


      /****************************************************************
       * Cogito
       ****************************************************************/
      // Cogito - Preinscriptions
      { path: 'cogito-preinscriptions', component: CogitoPreinscriptionComponent, canActivate: [PermissionGuard], data: { perm: 'cogito_access' } },
      {
        path: 'cogito-preinscriptions', data: { title: "cogito.title_preinscription_fil_ariane" },
        children: [
          { path: 'new', component: EditCogitoPreinscriptionComponent, canActivate: [PermissionGuard], data: { perm: 'cogito_create', title: "cogito.new_preinscription" } },
          { path: 'new/:idDemarche', component: DemarcheComponent, canActivate: [PermissionGuard], data: { perm: 'cogito_create' } },
          { path: ':id', component: EditCogitoPreinscriptionComponent, canActivate: [PermissionGuard], data: { perm: 'cogito_edit', title: "cogito.edit_preinscription" } },
        ]
      },
      // Cogito - Inscriptions
      { path: 'cogito-inscriptions', component: CogitoInscriptionsComponent, canActivate: [PermissionGuard], data: { perm: 'cogito_inscriptions_access' } },
      {
        path: 'cogito-inscriptions', data: { title: "cogito.title_inscription_fil_ariane" },
        children: [
          { path: 'new', component: EditCogitoInscriptionComponent, canActivate: [PermissionGuard], data: { perm: 'cogito_inscriptions_create', title: "cogito.new_inscription" } },
          { path: 'new/:idDemarche', component: DemarcheComponent, canActivate: [PermissionGuard], data: { perm: 'cogito_inscriptions_create' } },
          { path: ':id', component: EditCogitoInscriptionComponent, canActivate: [PermissionGuard], data: { perm: 'cogito_inscriptions_edit', title: "cogito.edit_inscription" } },
        ]
      },

      /****************************************************************
       * Compte Assmat
       ****************************************************************/
      { path: 'assmat', component: AssmatInfoComponent, canActivate: [PermissionGuard], data: { perm: 'enabled_assmat_account' } },
      { path: 'contrat-accueil-mentalo', component: ContratAccueilMentaloListComponent, canActivate: [PermissionGuard], data: { perm: 'contrat_accueil_access' } },
      { path: 'animations', component: ListAnimationsComponent, canActivate: [PermissionGuard], data: { perm: 'animations_access' } },
      { path: 'reunions', component: ListReunionsComponent, canActivate: [PermissionGuard], data: { perm: 'reunions_access' } },
      { path: 'assmat-pointage', component: AssmatPointageComponent, canActivate: [PermissionGuard], data: { disableAccountSwitch: true, perm: 'planning_pointage_access' } },
      //Assmat info
      {
        path: 'assmat', data: { title: 'Assistant maternel', disableAccountSwitch: true }, children: [
          { path: 'formation', component: AssmatFormationComponent, canActivate: [PermissionGuard], data: { perm: 'formations_edit', title: "Formations" } },
          { path: 'availability', component: AssmatAvailabilityComponent, canActivate: [PermissionGuard], data: { perm: 'disponibilites_edit', title: "Disponibilités" } },
          { path: 'edit', component: AssmatInfoEditComponent, canActivate: [PermissionGuard], data: { perm: 'informations_assmat_edit' } },
          { path: ':step', component: AssmatInfoEditComponent },
        ]
      },

      //Contrats accueil mentalo
      {
        path: 'contrat-accueil-mentalo', data: { title: 'Contrat d\'accueil' }, children: [
          {
            path: 'add', component: ContratAccueilMentaloEditComponent, canActivate: [PermissionGuard],
            data: { title: "Nouveau contrat d'accueil", perm: 'contrat_accueil_create' }
          },
          {
            path: 'edit/:id', component: ContratAccueilMentaloEditComponent, canActivate: [PermissionGuard],
            data: { title: "Modification contrat d'accueil", perm: 'contrat_accueil_edit' }
          },
          {
            path: 'edit/:id/:step', component: ContratAccueilMentaloEditComponent
          }
        ]
      },

      {
        path: 'animations', data: { title: 'Animations' }, children: [
          {
            path: 'inscriptions', component: InscriptionAnimationsComponent, canActivate: [PermissionGuard],
            data: { title: "Inscriptions aux animations", perm: "animations_add" }
          }
        ]
      },

      {
        path: 'reunions', data: { title: 'Réunions' }, children: [
          {
            path: 'inscriptions', component: InscriptionReunionsComponent, canActivate: [PermissionGuard],
            data: { title: "Inscriptions aux réunions", perm: "reunions_add" }
          }]
      },

      /****************************************************************
       * Compte Enseignant
       ****************************************************************/
      { path: 'enseignant-planning', component: EnseignantPointageComponent, canActivate: [PermissionGuard], data: { disableAccountSwitch: true, perm: 'enseignant_planning_pointage_access', title: "Planning enseignant" } },
      { path: 'enseignant-evaluation', component: ListEvaluationComponent, canActivate: [PermissionGuard], data: { disableAccountSwitch: true, perm: 'enseignant_evaluation_access', title: "Évaluations" } },
      { path: 'enseignant-eleves', component: EnseignantElevesComponent, data: { disableAccountSwitch: true, title: "Élèves" } },

      {
        path: 'enseignant-planning', data: { title: "Planning enseignant" }, children: [
          { path: 'students-pointage/:idJourCours', component: StudentsPointageComponent, canActivate: [PermissionGuard], data: { disableAccountSwitch: true, perm: 'enseignant_planning_pointage_access', title: "Pointage des élèves" } }
        ]
      },
      {
        path: 'enseignant-evaluation', data: { title: 'Évaluations' }, children: [
          // {
          //   path: 'add', component: EditEvaluationComponent, canActivate: [PermissionGuard], data: { disableAccountSwitch: true, perm: 'enseignant_evaluation_create', title: "Ajout d'une évaluation" }
          // },
          {
            path: 'edit/:id', component: EditEvaluationComponent, canActivate: [PermissionGuard], data: { disableAccountSwitch: true, perm: 'enseignant_evaluation_edit', title: "Modification d'une évaluation" }
          }
        ]
      },
      {
        path: 'enseignant-info', component: EnseignantInfoComponent, canActivate: [PermissionGuard], data: { title: "Enseignant", perm: 'enseignant_info_access' }
      },

      /****************************************************************
       * Démarches personnalisées
       ****************************************************************/
      { path: 'demarches', component: DemarchesListComponent },
      {
        path: 'demarches', data: { title: "Démarches" }, children: [
          { path: ':idDemarche', component: DemarcheComponent, data: { disableAccountSwitch: true } },
        ]
      },

      /*****************************************************************
       * Carnet de liaison
       *****************************************************************/
      { path: 'carnet-liaison', component: CarnetLiaisonComponent, data: { title: 'Carnet de liaison' } },
    ]
  }
];

@NgModule({
  declarations: [
    ChildEditComponent,
    PreinscriptionEditComponent,
    UserReservationEditComponent,
    PlanningSelectDialogComponent,
    PlanningDetailsDialogComponent,
    MikadoNewPresenceComponent,
    PresenceRepeatComponent,
    AccountComponent,
    PaiementComponent,
    FoyerComponent,
    FoyerEditComponent,
    ConjointEditComponent,
    GedComponent,
    ReservationPanierComponent,
    AssmatPointageComponent,
    TicketDematComponent,
    AchatTicketComponent,
    LasidoPreinscriptionComponent,
    LasidoPreinscriptionEditComponent,
    AssmatInfoEditComponent,
    AssmatInfoComponent,
    AssmatAvailabilityComponent,
    AssmatFormationComponent,
    ContratAccueilMentaloListComponent,
    ContratAccueilMentaloEditComponent,
    InscriptionAnimationsComponent,
    InscriptionReunionsComponent,
    ListAnimationsComponent,
    ListReunionsComponent,
    PresenceListComponent,
    LasidoInscriptionComponent,
    RenouvellementInscriptionComponent,
    CogitoPreinscriptionComponent,
    EditCogitoPreinscriptionComponent,
    ListAnimationsReunionsComponent,
    EditPhotoComponent,
    CogitoInscriptionsComponent,
    EditCogitoInscriptionComponent,
    MandatsSepaComponent,
    MandatSepaEditComponent,
    FilePreviewComponent,
    FileUploadDialogComponent,
    DocDetailsComponent,
    MandatSepaPdfDialogComponent,
    DiaboloInscriptionsComponent,
    EditDiaboloInscriptionsComponent,
    TotpManageComponent,
    EnseignantPointageComponent,
    StudentsPointageComponent,
    DemarchesListComponent,
    DemarcheComponent,
    DemarcheGedComponent,
    DemarcheSelectStepComponent,
    DemarcheQuestionStepComponent,
    ListEvaluationComponent,
    EditEvaluationComponent,
    EvaluationCardViewComponent,
    EvaluationTableViewComponent,
    EnseignantElevesComponent,
    DossierPedagogiqueDialogComponent,
    DemandeContratAccueilComponent,
    DemandeContratAccueilEditComponent,
    CarnetLiaisonComponent
  ],
  imports: [
    SharedModule,
    PublicModule,
    RouterModule.forChild(userRoutes),
    // composants standalone et pipes
    CarnetHeureFormatPipe,
    CarnetDureeFormatPipe,
    CarnetTransmissionParentComponent,
    CarnetRepasComponent,
    CarnetSommeilComponent,
    CarnetHygieneComponent,
    CarnetActiviteComponent,
    CarnetMomentDeVieComponent,
    CarnetTraitementComponent,
    CarnetTransmissionProComponent,
    CarnetDevPsychomoteurComponent,
    CarnetLangageComponent,
    CarnetDiversificationComponent,
    CarnetDevPhysiologiqueComponent,
    EnseignantInfoComponent,
    AvailabilityComponent,
    DepartmentTreeComponent
  ],
  providers: [
    EditionsGuard
  ],
  exports: [
    RouterModule
  ]
})
export class UserModule { }
